export default {
	workOrder: [], // Why is this an array while it's treated as an object in History Details?
	GSTData: [],
	bookingHistoryAddress: "",
}